import { render, staticRenderFns } from "./promotion-detail.vue?vue&type=template&id=38b53466&"
import script from "./promotion-detail.vue?vue&type=script&lang=js&"
export * from "./promotion-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports